import { getItem } from '@sketch/utils';
import './envs.js';
import environments from './environments.json.js';

const ensureValidAppEnv = (env = 'production') => {
    return environments[env] ? env : 'production';
};
const getCurrentEnv = () => {
    if (process.env.REACT_APP_ENV === 'production') {
        return 'production';
    }
    const appEnv = getItem('app_env');
    if (appEnv) {
        console.warn(`Using '${appEnv}' environment from local storage.`);
        console.warn(`Use localStorage.removeItem('app_env') to reset.`);
        return ensureValidAppEnv(appEnv);
    }
    return ensureValidAppEnv(process.env.REACT_APP_ENV);
};
const CURRENT_ENV = getCurrentEnv();
// Utility to check if the current frontend built is running on staging environment (intended to be released on staging.sketch.cloud)
const isDeployedInStaging = () => process.env.REACT_APP_ENV === 'staging' &&
    process.env.NODE_ENV === 'production';
// Utility to check if the current frontend built is production ready (intended to be released on www.sketch.cloud)
const isDeployedInProduction = () => process.env.REACT_APP_ENV === 'production' &&
    process.env.NODE_ENV === 'production';
// Utility to check if the current target (backend) environment is the production environment.
const isProduction = () => CURRENT_ENV === 'production';
var appEnv = environments[CURRENT_ENV];

export { CURRENT_ENV, appEnv as default, isDeployedInProduction, isDeployedInStaging, isProduction };
